import { FC, useState } from 'react';
import Box from '@mui/material/Box/Box';

import { Layout } from 'components/Layout';
import { MetaHead } from 'components/MetaHead';
import { ContactModal } from 'components/Header/ContactModal';

import { Hero } from './Hero/Hero';
import { Results } from './Results/Results';
import TextWithImage from './TextWithImage/TextWithImage';
import { InformationBlock } from './InformationBlock/InformationBlock';

import type { PageMeta } from 'constants/pages';

import { ICustomerCaseData } from 'types/customer-case';

interface ICustomerCaseProps {
  pageMeta: PageMeta;
  data: ICustomerCaseData;
}

export const CustomerCaseTemplate: FC<ICustomerCaseProps> = ({ pageMeta, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen((value) => !value);

  return (
    <Layout>
      <MetaHead pageMeta={pageMeta} />

      <Hero {...data.heroData} />

      <Box display="flex" flexDirection="column" width="100%" margin="0 auto" alignItems="center">
        <Box
          maxWidth="1200px"
          padding={{
            lg: '0',
            sm: '0 24px',
            xxs: '0 16px',
          }}
        >
          <TextWithImage type="default" {...data.customerCase} />
        </Box>

        <InformationBlock data={data.firstInformationBlockData} showArrow isFirstSection={true} />

        <Box
          maxWidth="1200px"
          padding={{
            lg: '0',
            sm: '0 24px',
            xxs: '0 16px',
          }}
        >
          <Results {...data.resultsData} />
        </Box>

        <InformationBlock data={data.secondInformationBlockData} isFirstSection={false} />

        <Box
          maxWidth="1200px"
          padding={{
            lg: '0',
            sm: '0 24px',
            xxs: '0 16px',
          }}
        >
          <TextWithImage type="customer-case" {...data.applicationData} />
        </Box>
      </Box>

      <ContactModal onClose={toggleModal} isOpen={isModalOpen} />
    </Layout>
  );
};
